import React, { useEffect, useMemo, cloneElement } from "react";

import { debounce } from "lodash";

interface WithDebounceProps {
  /** The element whose onChange we want to delay. */
  children: React.ReactElement;
  /** Milliseconds to delay the onChange function. */
  debounceTime?: number;
  /** The onChange of the child element that we want to delay. */
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

/** IMPORTANT: This will only work with uncontrolled inputs! */
const WithDebounce = ({
  children,
  debounceTime = 500,
  onChange,
}: WithDebounceProps) => {
  const debounceSearchFunction = useMemo(
    () =>
      debounce((e) => {
        if (onChange) {
          onChange(e);
        }
      }, debounceTime),
    []
  );

  useEffect(() => {
    return () => {
      debounceSearchFunction.cancel();
    };
  }, []);
  return cloneElement(children, {
    onChange: debounceSearchFunction,
  });
};

export default WithDebounce;
